import Vue from 'vue'
import Vuex from 'vuex'
import claim from './modules/claim'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

/**
 * Our Vuex store to manage global app state as a single source of truth
 */
export default new Vuex.Store({
  modules: {
    claim
  },
  strict: debug,
  // todo add logger when on debug builds
  plugins: debug ? [] : []
})
